import { Controller } from "@hotwired/stimulus";

// Floating hover bubble for player avatars. The bubble is appended to <body>
// with fixed positioning so it is never clipped by an overflow-hidden ancestor
// (cards, scrollable stat tables, modals).
export default class extends Controller {
  static values = { text: String };

  disconnect() {
    this.hide();
  }

  show() {
    if (this.bubble || !this.hasTextValue || !this.textValue) return;

    this.bubble = document.createElement("div");
    this.bubble.textContent = this.textValue;
    // Inline styles (not Tailwind classes): this element is created in JS, which
    // Tailwind does not scan, so utility classes would be purged.
    // z-index above the modal overlay (9999) so the bubble shows inside modals.
    this.bubble.style.cssText =
      "position:fixed;z-index:10000;white-space:nowrap;border-radius:4px;" +
      "background:rgba(17,24,39,0.95);color:#fff;font-size:0.75rem;font-weight:500;" +
      "line-height:1rem;padding:4px 8px;pointer-events:none;" +
      "box-shadow:0 4px 12px rgba(0,0,0,0.25);";
    document.body.appendChild(this.bubble);

    this.reposition = this.position.bind(this);
    window.addEventListener("scroll", this.reposition, true);
    window.addEventListener("resize", this.reposition);
    this.position();
  }

  position() {
    if (!this.bubble) return;

    const anchor = this.element.getBoundingClientRect();
    const { width, height } = this.bubble.getBoundingClientRect();
    const left = Math.max(
      4,
      Math.min(anchor.left + anchor.width / 2 - width / 2, window.innerWidth - width - 4)
    );

    this.bubble.style.left = `${left}px`;
    this.bubble.style.top = `${anchor.top - height - 6}px`;
  }

  hide() {
    if (!this.bubble) return;

    window.removeEventListener("scroll", this.reposition, true);
    window.removeEventListener("resize", this.reposition);
    this.bubble.remove();
    this.bubble = null;
  }
}
